import { css } from 'styled-components';

import { get as getTheme } from 'Components/Base/constants';

export default css`
  * {
    line-height: 1.75;
    overflow-wrap: break-word;
  }
  strong {
    font-weight: ${getTheme('fontWeights.medium')};
  }
  h3 {
    font-size: ${getTheme('fontSizes.4')};
    font-weight: ${getTheme('fontWeights.medium')};
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${getTheme('fonts.contentReadable')};
  }

  p {
    margin: 0 0 ${getTheme('space.4')}px;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #4183c4;
    text-decoration: underline;
  }
  pre {
    background-color: rgba(253, 225, 175, 0.5);
    border-radius: 12px;
    padding: ${getTheme('space.6')}px;
    white-space: pre-wrap;
  }
  blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    border-left: 5px solid #eee;
    color: #93a1a1;
  }
  code {
    padding: 2px 4px;
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
  }
  .table-responsive {
    width: 100%;
    overflow-x: auto;
    margin-bottom: ${getTheme('space.4')}px;
  }
  table {
    & > * {
      color: ${getTheme('colors.greyscale.grey1')};
      font-family: ${getTheme('fonts.content')};
    }
    th {
      padding: ${getTheme('space.2')}px;
      line-height: ${getTheme('lineHeights.normal')};
      border-bottom: 2px solid ${getTheme('colors.greyscale.grey4')};
    }
    tbody {
      tr:nth-child(odd) {
        background-color: ${getTheme('colors.greyscale.grey5')};
      }
      td {
        padding: ${getTheme('space.2')}px;
        line-height: ${getTheme('lineHeights.normal')};
      }
    }
  }
`;
